import { AdmiralCard } from '../AdmiralCard';
import { Button, Col, Row } from 'react-bootstrap';
import { get, map } from 'lodash';
import { Field, InjectedFormProps } from 'redux-form';
import FieldFormControl from '../../../../../components/FieldFormControl';
import {
  allowOnlyApostrophes,
  hasEmojis,
  hasSpecialCharacters,
  isEmail,
  isPhone,
  isRequired,
} from '../../../../../util/validators';
import { IChannel, ITraveller } from '../../../../../data/api/models';
import { PostcodeLookup } from '../PostcodeLookup';
import { TITLES } from '../../../../../helpers/Quote';
import { ErrorDisplay } from '../../../../../components/FieldFormControl/ErrorDisplay';
import { Collapsable, ICollapsableComponent } from '../../../../../services/quote/models';
import { setCollapsable } from '../../../../../services/quote/reducer';
import React = require('react');

interface IAboutYouProps extends InjectedFormProps {
  selection: ITraveller;
  index: number;
  type: string;
  isRenewal: boolean;
  channel: IChannel;
  dob: any;
  synchronousError: any;
  travellers: ITraveller[];
  errorDob?: any;
  dispatch?: any;
  collapsable?: ICollapsableComponent

  change(field: string, value: any): void;
}

export const AboutYou = ({
                           selection,
                           index,
                           type,
                           isRenewal,
                           change,
                           dob,
                           travellers,
                           errorDob,
                           dispatch,
                           collapsable,
                           synchronousError, ...props
                         }: IAboutYouProps) => {

  const selectedTitle = get(selection, 'title', '');

  const onChangeCollapse = () => {
    dispatch(setCollapsable(null, Collapsable.ABOUT_YOU));
  }

  const handleContinue = () => {
    dispatch(setCollapsable(Collapsable.ABOUT_YOU, Collapsable.COVER_LEVEL));
  }

  const renderInputs = () => {
    return (
      <>
        <Row>
          <Col xs={6} className={'full-width-xs'}>Your preferred title</Col>
          <Col xs={6} className={'full-width-xs title-selection-container'}>
            {map(TITLES, (value, key) => {
              const isSelected = selectedTitle === value;
              return (
                <Col xs={4} className={isSelected ? 'traveller-title-selection selected' : 'traveller-title-selection'}>
                  <div>
                    <Field
                      name={`travellers[${index}].title`}
                      id={key + '-btn'}
                      type="radio"
                      value={value}
                      component={FieldFormControl}
                      validate={[isRequired]}
                    >
                      <div className={`trip-type-btn ${key}`}>
                        <div className={'trip-type-selection-container'}>
                          {value}
                        </div>
                      </div>
                    </Field>
                  </div>
                </Col>
              )
            })}
          </Col>
        </Row>
        <Row className={'adm-form-group'}>
          <Col xs={6} className={'full-width-xs'}>First Name</Col>
          <Col xs={6} className={'full-width-xs'}>
            <Field
              name={`travellers[${index}].firstName`}
              type="text"
              component={FieldFormControl}
              validate={[isRequired, hasEmojis, hasSpecialCharacters]}
              autocomplete="new-password"
            />
          </Col>
        </Row>
        <Row className={'adm-form-group'}>
          <Col xs={6} className={'full-width-xs'}>Last Name</Col>
          <Col xs={6} className={'full-width-xs'}>
            <Field
              name={`travellers[${index}].lastName`}
              type="text"
              component={FieldFormControl}
              validate={[isRequired, hasEmojis, allowOnlyApostrophes]}
              autocomplete="new-password"
            />
          </Col>
        </Row>
        <Row className={'adm-form-group'}>
          <Col xs={6} className={'full-width-xs'}>Date of Birth</Col>
          <Col xs={2} className={'full-width-xs'}>
            <Field
              name={`travellers[${index}].dobSeparate.day`}
              inputmode="numeric"
              type="text"
              maxLength={'2'}
              placeholder={'DD'}
              className={'text-center'}
              component={FieldFormControl}
              validate={[isRequired]}
              autocomplete="new-password"
            />
            <div className={'text-center'}>Day</div>
          </Col>
          <Col xs={2} className={'full-width-xs'}>
            <Field
              name={`travellers[${index}].dobSeparate.month`}
              inputmode="numeric"
              type="text"
              maxLength={'2'}
              placeholder={'MM'}
              className={'text-center'}
              component={FieldFormControl}
              validate={[isRequired]}
              autocomplete="new-password"
            />
            <div className={'text-center'}>Month</div>
          </Col>
          <Col xs={2} className={'full-width-xs'}>
            <Field
              name={`travellers[${index}].dobSeparate.year`}
              inputmode="numeric"
              type="text"
              maxLength={'4'}
              placeholder={'YYYY'}
              className={'text-center'}
              component={FieldFormControl}
              validate={[isRequired]}
              autocomplete="new-password"
            />
            <div className={'text-center'}>Year</div>
          </Col>
          <Col xs={6}/>
          <Col xs={6} className={'full-width-xs'}>
            <ErrorDisplay error={errorDob}/>
          </Col>
        </Row>
        <Row className={'adm-form-group'}>
          <Col xs={6} className={'full-width-xs'}>Email address</Col>
          <Col xs={6} className={'full-width-xs'}>
            <Field
              name={`travellers[${index}].email`}
              type="email"
              component={FieldFormControl}
              validate={[isRequired, isEmail]}
              disabled={index === 0 && isRenewal}
              autocomplete="new-password"
            />
          </Col>
        </Row>
        <Row className={'adm-form-group'}>
          <Col xs={6} className={'full-width-xs'}>Phone number</Col>
          <Col xs={6} className={'full-width-xs'}>
            <Field
              name={`travellers[${index}].phone`}
              inputmode="numeric"
              type="text"
              component={FieldFormControl}
              validate={[isRequired, isPhone]}
              disabled={index === 0 && isRenewal}
              autocomplete="new-password"
            />
          </Col>
        </Row>
        <PostcodeLookup change={change}
                        basePath={'travellers[0].address'}
                        travellers={travellers}
                        showManualEntry={true}
                        title={'Home postcode'}
                        {...props}/>
        <Row>
          <Col xs={12}>
            <Button
              bsSize={'small'}
              type="button"
              disabled={!props.valid || !travellers?.[0]?.address?.line1 || errorDob}
              block={true}
              onClick={handleContinue}
              className={'admiral-primary-btn'}>
              CONTINUE
            </Button>
          </Col>
        </Row>
      </>
    )
  }

  const renderTravelerInfo = (traveler?: ITraveller) => {
    return traveler && traveler.firstName && traveler.lastName && (
      <div>
        <div>{traveler.title} {traveler.firstName} {traveler.lastName}</div>
        {traveler.dobSeparate?.day && traveler.dobSeparate?.month && traveler.dobSeparate?.year && (
          <div>Date of Birth: {[
            traveler.dobSeparate.day,
            traveler.dobSeparate.month,
            traveler.dobSeparate.year,
          ].join('/')}</div>
        )}
        <div>Email Address: {traveler.email}</div>
        <div>Address: {[
          traveler.address?.line1,
          traveler.address?.line2,
          traveler.address?.line3,
          traveler.address?.town,
          traveler.address?.postcode,
        ].filter(x => x).join(', ')}</div>
      </div>
    );
  }

  return (
    <AdmiralCard
      icon={'person.svg'}
      title={'About you'}
      collapsable={collapsable.aboutYou}
      handleCollapse={onChangeCollapse}
      headerMessage={'The lead Traveller and policy holder.'}
      headerMessageOnCollapsed={renderTravelerInfo(travellers?.[0])}
    >
      {renderInputs()}
    </AdmiralCard>
  )
}
